module.exports = __webpack_public_path__ + "img/Sayi.af0fdf1.png";